export enum ArchiveButtonTypeEnum {
  archive = "Arquivar",
  unarchive = "Desarquivar"
}



// WEBPACK FOOTER //
// ./src/components/Refatoracao/Archive/ArchiveButtonTypeEnum.ts